// extracted by mini-css-extract-plugin
export default {"wrapper":"yy-z","viewport":"zy-z","container":"Ay-z","slide":"By-z"};